const isScriptAlreadyInserted = scriptId => {
    return !!document.getElementById(scriptId)
}

const insertScriptWithId = (scriptId, scriptContent) => {
    if (!isScriptAlreadyInserted(scriptId)) {
        const scriptElement = document.createElement("script")
        scriptElement.id = scriptId
        scriptElement.text = scriptContent
        document.body.appendChild(scriptElement)
    }
}

export default insertScriptWithId
